module.exports = __webpack_public_path__ + "img/lighting-repair-replacement-01-xxlarge.76c83f4b.jpg";